/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddJiraEpicsInput = {|
  jiraEpicIds?: ?$ReadOnlyArray<?string>,
  forecastProjectId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type AddJiraEpicsMutationVariables = {|
  input: AddJiraEpicsInput
|};
export type AddJiraEpicsMutationResponse = {|
  +addJiraEpics: ?{|
    +company: ?{|
      +unSynchedJiraEpics: ?$ReadOnlyArray<?{|
        +id: string,
        +key: ?string,
        +summary: ?string,
      |}>
    |},
    +project: ?{|
      +id: string,
      +isJiraProject: ?boolean,
      +jiraCloudEpics: ?$ReadOnlyArray<?{|
        +id: string,
        +key: ?string,
        +summary: ?string,
      |}>,
    |},
  |}
|};
export type AddJiraEpicsMutation = {|
  variables: AddJiraEpicsMutationVariables,
  response: AddJiraEpicsMutationResponse,
|};
*/


/*
mutation AddJiraEpicsMutation(
  $input: AddJiraEpicsInput!
) {
  addJiraEpics(input: $input) {
    company {
      unSynchedJiraEpics {
        id
        key
        summary
      }
      id
    }
    project {
      id
      isJiraProject
      jiraCloudEpics {
        id
        key
        summary
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddJiraEpicsInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "summary",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraCloudIssueType",
  "kind": "LinkedField",
  "name": "unSynchedJiraEpics",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJiraProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraCloudIssueType",
      "kind": "LinkedField",
      "name": "jiraCloudEpics",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddJiraEpicsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJiraEpicsPayload",
        "kind": "LinkedField",
        "name": "addJiraEpics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddJiraEpicsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJiraEpicsPayload",
        "kind": "LinkedField",
        "name": "addJiraEpics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AddJiraEpicsMutation",
    "operationKind": "mutation",
    "text": "mutation AddJiraEpicsMutation(\n  $input: AddJiraEpicsInput!\n) {\n  addJiraEpics(input: $input) {\n    company {\n      unSynchedJiraEpics {\n        id\n        key\n        summary\n      }\n      id\n    }\n    project {\n      id\n      isJiraProject\n      jiraCloudEpics {\n        id\n        key\n        summary\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e536be41dadb96ed2928032503e5d126';

module.exports = node;
